module.exports = "<div class=\"loader\"></div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/busy-loader/busy-loader.component.html
// module id = 923
// module chunks = 9